var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item
    ? _c("ItpFormSelect2", {
        attrs: {
          name: _vm.path,
          dataSource: _vm.b_7315092382398562_dataSource,
          prefetch: "",
          autofocus: _vm.autofocus,
          "bind-object": "",
          disabled: _vm.readonly || _vm.item.isReadonly,
          readonly: _vm.readonly || _vm.item.isReadonly,
          required: _vm.required,
          initialOptions: _vm.initialOptionsInternal,
          valueField: "id",
          optionTemplate: _vm.b_7315092382398562_optionTemplate,
          "use-option-template-for-selected-option": ""
        },
        model: {
          value: _vm.item[_vm.path],
          callback: function($$v) {
            _vm.$set(_vm.item, _vm.path, $$v)
          },
          expression: "item[path]"
        }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }